import { render } from "./RoadMap.vue?vue&type=template&id=e4391638"
import script from "./RoadMap.vue?vue&type=script&lang=ts"
export * from "./RoadMap.vue?vue&type=script&lang=ts"
script.render = render

export default script